import { UseQueryOptions } from '@tanstack/react-query';
import {
	BuildInfoControllerPath,
	BuildInfoPayload,
	GetBuildInfoPath,
	IBuildInfo,
	urlCombine,
} from 'ihub/common';
import { coreAPI, isURLSet, standardPost, validateOkResponse } from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';

export class BuildInfoHttpService {
	getBuildInfoQuery(
		buildInfoPayload: BuildInfoPayload
	): UseQueryOptions<IBuildInfo, unknown, IBuildInfo> {
		return {
			queryKey: [`build-info`],
			queryFn: async (): Promise<IBuildInfo> => {
				isURLSet();
				const url = urlCombine(coreAPI, BuildInfoControllerPath, GetBuildInfoPath);
				const res = await standardPost(url, buildInfoPayload);
				await validateOkResponse(res, 'get', 'Build Info');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}
}
